import { TenantApp } from 'application/Shared/types/tenantApp';

export interface LicenseProps {
    tenantApp: TenantApp;
}

export enum LicenseDataStatus {
    available = 'available',
    notConnected = 'notConnected',
    syncFailed = 'syncFailed',
    unavailable = 'unavailable'
}

export const LicenseDataFilter = [
    LicenseDataStatus.available,
    LicenseDataStatus.notConnected,
    LicenseDataStatus.syncFailed,
    LicenseDataStatus.unavailable
];
